import TourPage from "@/components/TourPage";

export default function PrimatesSafari5Day() {
  return (
    <TourPage
      tourId="rwanda/primates-5-day"
      title="5 Days Rwanda Primates Safari"
      duration="5 Days / 4 Nights"
      price="Contact for price"
      image="/nyunguwemonkey.jpeg"
      description="Immerse yourself on this 5-day adventure to explore Rwanda's incredible primate species. This safari takes you to Nyungwe Forest National Park for chimpanzee trekking and Volcanoes National Park for mountain gorilla trekking."
      itinerary={[
        {
          day: 1,
          title: "Transfer to Nyungwe Forest National Park",
          description: "Begin your primate adventure with a journey to Nyungwe Forest.",
          activities: [
            "Pick up from Kigali International Airport or hotel",
            "Visit the King's Palace Museum, Ethnographic Museum, and Murambi Genocide memorial",
            "Transfer to Nyungwe Forest National Park for check-in"
          ],
          accommodation: "Nyungwe Forest Lodge",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Chimpanzee Trekking and Canopy Walk in Nyungwe Forest National Park",
          description: "Experience the incredible primate life and unique canopy walk.",
          activities: [
            "Early morning chimpanzee trekking in Nyungwe Forest National Park",
            "Canopy walk experience in the afternoon"
          ],
          accommodation: "Nyungwe Forest Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Transfer to Volcanoes National Park",
          description: "Journey to the home of mountain gorillas.",
          activities: [
            "Breakfast and transfer to Volcanoes National Park",
            "Enjoy scenic views of the countryside"
          ],
          accommodation: "Volcanoes Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Mountain Gorilla Trek and Visit Gorilla Guardian Village",
          description: "The highlight of your Rwanda adventure.",
          activities: [
            "Morning briefing at Kinigi Park offices",
            "Mountain gorilla trekking in Volcanoes National Park",
            "Visit the Iby'wacu Cultural Village (Gorilla guardian village)"
          ],
          accommodation: "Volcanoes Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Golden Monkey Trekking and Transfer Back to Kigali",
          description: "Final primate encounter before departure.",
          activities: [
            "Golden monkey trekking in Volcanoes National Park",
            "Transfer back to Kigali for drop-off at your hotel or airport"
          ],
          meals: "Breakfast"
        }
      ]}
      inclusions={[
        "Local transportation",
        "Accommodation",
        "Professional guide",
        "All park entrance fees and permits",
        "All activities mentioned in the itinerary"
      ]}
      exclusions={[
        "International flights (from/to home)",
        "Personal items (souvenirs, travel insurance, visa fees, etc.)",
        "Tip",
        "Coffee, soft drinks, snacks, and drinking water (on all days)",
        "Government-imposed increase of taxes and/or park fees"
      ]}
    />
  );
}
